const embeddedTrackLanguageCodes = `
aar abk ace ach ada ady afa afh afr ain aka akk ale alg alt amh
ang anp apa ara arc arg arn arp art arw asm ast ath aus ava ave
awa aym aze bad bai bak bal bam ban bas bat bej bel bem ben ber
bho bih bik bin bis bla bnt tib bod bos bra bre btk bua bug bul
byn cad cai car cat cau ceb cel cze ces cha chb che chg chk chm
chn cho chp chr chu chv chy cmc cnr cop cor cos cpe cpf cpp cre
crh crp csb cus wel cym dak dan dar day del den ger deu dgr din
div doi dra dsb dua dum dyu dzo efi egy eka gre ell elx eng enm
epo est baq eus ewe ewo fan fao per fas fat fij fil fin fiu fon
fre fra frm fro frr frs fry ful fur gaa gay gba gem gez gil gla
gle glg glv gmh goh gon gor got grb grc grn gsw guj gwi hai hat
hau haw heb her hil him hin hit hmn hmo hrv hsb hun hup arm hye
iba ibo ido iii ijo iku ile ilo ina inc ind ine inh ipk ira iro
ice isl ita jav jbo jpn jpr jrb kaa kab kac kal kam kan kar kas
geo kat kau kaw kaz kbd kha khi khm kho kik kin kir kmb kok kom
kon kor kos kpe krc krl kro kru kua kum kur kut lad lah lam lao
lat lav lez lim lin lit lol loz ltz lua lub lug lui lun luo lus
mad mag mah mai mak mal man map mar mas mdf mdr men mga mic min
mis mac mkd mkh mlg mlt mnc mni mno moh mon mos mao mri may msa
mul mun mus mwl mwr bur mya myn myv nah nai nap nau nav nbl nde
ndo nds nep new nia nic niu dut nld nno nob nog non nor nqo nso
nub nwc nya nym nyn nyo nzi oci oji ori orm osa oss ota oto paa
pag pal pam pan pap pau peo phi phn pli pol pon por pra pro pus
qaa-qtz que raj rap rar roa roh rom rum ron run rup rus sad sag sah
sai sal sam san sas sat scn sco sel sem sga sgn shn sid sin sio
sit sla slo slk slv sma sme smi smj smn smo sms sna snd snk sog
som son sot spa alb sqi srd srn srp srr ssa ssw suk sun sus sux
swa swe syc syr tah tai tam tat tel tem ter tet tgk tgl tha tig
tir tiv tkl tlh tli tmh tog ton tpi tsi tsn tso tuk tum tup tur
tut tvl twi tyv udm uga uig ukr umb und urd uzb vai ven vie vol
vot wak wal war was wen wln wol xal xho yao yap yid yor ypk zap
zbl zen zgh zha chi zho znd zul zun zxx zza
`
    .trim()
    .split(/\s+/);

export function embeddedTrackLanguageDisplayName(language: string): string {
    try {
        return (
            new Intl.DisplayNames(['en'], {
                type: 'language',
                languageDisplay: 'standard',
                fallback: 'none',
            }).of(language) ?? language
        );
    } catch {
        return language;
    }
}

export const embeddedTrackLanguages = embeddedTrackLanguageCodes
    .map((code) => ({ code, name: embeddedTrackLanguageDisplayName(code) }))
    .filter(({ code, name }) => code !== name)
    .sort((a, b) => a.name.localeCompare(b.name) || a.code.localeCompare(b.code))
    .filter((language, index, languages) => index === 0 || language.name !== languages[index - 1].name);
